import { Data, FormProps } from "@/types";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import AppContext from "@/context/appContext";
import Input from "./input";

export default function NonDesktopInputs2({
  formDetails,
  setErrorMessage,
  inputErrors,
}: FormProps) {
  const { t } = useTranslation("main");
  const { inputData, setInputData } = useContext(AppContext);

  return (
    <div>
      {formDetails.map(
        (
          {
            title,
            placeholder,
            border,
            inputId1,
            inputId2,
            errorsType1,
            errorsType2,
          },
          i,
        ) => (
          <div key={title}>
            <strong className="mb-5 block text-sm sm:text-md">{title}</strong>
            <div className="relative mb-4 flex justify-between">
              <div className="flex flex-col text-sm">
                <label className="text-sm font-semibold" htmlFor={inputId1}>
                  {t("strategic_projects")}
                </label>
                <p>{t("up_to")}</p>
              </div>
              <Input
                onChange={(e) => {
                  const value = e.target.valueAsNumber;
                  if (value && value < 1) {
                    setErrorMessage(
                      i,
                      errorsType1,
                      t("input_error.at_least_1"),
                    );
                  } else if (value && !Number.isInteger(value)) {
                    setErrorMessage(
                      i,
                      errorsType1,
                      t("input_error.whole_number"),
                    );
                  } else {
                    setInputData &&
                      setInputData({ ...inputData, [inputId1]: value });
                    setErrorMessage(i, errorsType1, "");
                  }
                }}
                onBlur={(e) => {
                  if (!e.target.value) {
                    setErrorMessage(i, errorsType1, t("input_error.required"));
                  }
                }}
                variant={inputErrors[errorsType1][i] ? "error" : "normal"}
                inputSize="small"
                placeholder={placeholder && placeholder}
                id={inputId1}
                value={(inputData && inputData[inputId1 as keyof Data]) || ""}
                type="number"
                inputMode="numeric"
                min="1"
                aria-invalid={inputErrors[errorsType1][i] ? "true" : "false"}
              />
              {inputErrors[errorsType1][i] && (
                <p
                  className="absolute -bottom-2 right-2 rounded-lg border border-red-600 bg-white px-1 py-[0.1rem] text-red-600"
                  role="alert"
                >
                  {inputErrors[errorsType1][i]}
                </p>
              )}
            </div>

            <div className="relative flex justify-between">
              <div className="flex flex-col text-xs sm:text-sm">
                <label className="font-semibold" htmlFor={inputId2}>
                  {t("major_projects")}
                </label>
                <p>{t("over")}</p>
              </div>
              <Input
                onChange={(e) => {
                  const value = e.target.valueAsNumber;
                  if (value && value < 1) {
                    setErrorMessage(
                      i,
                      errorsType2,
                      t("input_error.at_least_1"),
                    );
                  } else if (value && !Number.isInteger(value)) {
                    setErrorMessage(
                      i,
                      errorsType2,
                      t("input_error.whole_number"),
                    );
                  } else {
                    setInputData &&
                      setInputData({ ...inputData, [inputId2]: value });
                    setErrorMessage(i, errorsType2, "");
                  }
                }}
                onBlur={(e) => {
                  if (!e.target.value) {
                    setErrorMessage(i, errorsType2, t("input_error.required"));
                  }
                }}
                variant={inputErrors[errorsType2][i] ? "error" : "normal"}
                inputSize="small"
                placeholder={placeholder && placeholder}
                id={inputId2}
                value={(inputData && inputData[inputId2 as keyof Data]) || ""}
                type="number"
                inputMode="numeric"
                min="1"
                aria-invalid={inputErrors[errorsType2][i] ? "true" : "false"}
              />
              {inputErrors[errorsType2][i] && (
                <p
                  className="absolute -bottom-2 right-2 rounded-lg border border-red-600 bg-white px-1 py-[0.1rem] text-red-600"
                  role="alert"
                >
                  {inputErrors[errorsType2][i]}
                </p>
              )}
            </div>
            {border && (
              <div className="mx-auto mb-4 mt-6 h-[2px] bg-cd-purple" />
            )}
          </div>
        ),
      )}
    </div>
  );
}
